import {SortModel} from "../components/Tables/types";

/**
 * The comparator every customer-number column uses. It lives in `sharedlibs`
 * because the server sorts the Excel export with the sort model of the table it
 * was triggered from — the file and the table have to agree, so both sides use
 * the same implementation rather than two that are meant to match.
 */
export {compareCustomerNumbers} from "sharedlibs";

/**
 * The default sort every table that shows a customer number opens with: customer
 * number ascending (low to high). Shared so the pages can't drift apart.
 *
 * Frozen because this one array is handed straight to several `useState`
 * initialisers and `options.sortModel` props — an in-place sort or push anywhere
 * would silently change every other table's default.
 */
export const CUSTOMER_NUMBER_SORT_MODEL: SortModel =
  Object.freeze([Object.freeze({field: "customerNumber", sort: "asc" as const})]) as SortModel;
